import { FC } from "react";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { ArrowBack, Refresh } from "@mui/icons-material";
import DeviceInfoSection from "./components/DeviceInfoSection";
import useMiniScentDetailModel from "./useMiniScentDetailModel";
import UsageStatsSection from "./components/UsageStatsSection";
import CartridgesSection from "./components/CartridgesSection";
import ShotHistorySection from "./components/ShotHistorySection";

const MiniScentDetailView: FC<ReturnType<typeof useMiniScentDetailModel>> = ({
  miniScentDevice,
  deviceUsageStats,
  miniScentCartridgeList,
  shotHistoryList,
  paginatedCartridges,
  paginatedShotHistory,
  isLoading,
  translate,
  cartridgePage,
  cartridgeRowsPerPage,
  handleCartridgePageChange,
  handleCartridgeRowsPerPageChange,
  shotHistoryPage,
  shotHistoryRowsPerPage,
  handleShotHistoryPageChange,
  handleShotHistoryRowsPerPageChange,
  handleGoBack,
  handleRefresh,
}) => {
  return (
    <Box sx={{ p: 2 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            onClick={handleGoBack}
            sx={{
              backgroundColor: "action.hover",
              "&:hover": { backgroundColor: "action.selected" },
            }}
          >
            <ArrowBack />
          </IconButton>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              Detalhes do MiniScent
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Serial: {miniScentDevice?.serialNumber || "Carregando..."}
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={handleRefresh}
          title="Atualizar dados"
          sx={{
            backgroundColor: "action.hover",
            "&:hover": { backgroundColor: "action.selected" },
          }}
        >
          <Refresh />
        </IconButton>
      </Box>

      {/* Content Grid */}
      <Grid container spacing={3}>
        {/* Device Info & Usage Stats */}
        <Grid item xs={12} md={6}>
          <DeviceInfoSection
            device={miniScentDevice}
            isLoading={isLoading}
            translate={translate}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <UsageStatsSection
            stats={deviceUsageStats}
            isLoading={isLoading}
            translate={translate}
            totalCartridges={miniScentCartridgeList?.data.length || 0}
          />
        </Grid>

        {/* Cartridges Section */}
        <Grid item xs={12}>
          <CartridgesSection
            cartridges={paginatedCartridges}
            totalCartridges={miniScentCartridgeList?.data.length || 0}
            page={cartridgePage}
            rowsPerPage={cartridgeRowsPerPage}
            onPageChange={handleCartridgePageChange}
            onRowsPerPageChange={handleCartridgeRowsPerPageChange}
            isLoading={isLoading}
            translate={translate}
          />
        </Grid>

        {/* Shot History Section */}
        <Grid item xs={12}>
          <ShotHistorySection
            shotHistory={paginatedShotHistory}
            totalShots={shotHistoryList?.data.length || 0}
            page={shotHistoryPage}
            rowsPerPage={shotHistoryRowsPerPage}
            onPageChange={handleShotHistoryPageChange}
            onRowsPerPageChange={handleShotHistoryRowsPerPageChange}
            isLoading={isLoading}
            translate={translate}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MiniScentDetailView;
